var _circle, _circle2, _path, _circle3, _line, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisabledUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 450,
    height: 450,
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 95,
    fill: "#F3F4F7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 70,
    r: 25,
    fill: "#24C78A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 140c0-25 20-45 40-45s40 20 40 45v10H45v-10z",
    fill: "#24C78A"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 135,
    cy: 65,
    r: 28,
    fill: "#ffffff",
    stroke: "#FF5B5B",
    strokeWidth: 6
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 118,
    y1: 82,
    x2: 152,
    y2: 48,
    stroke: "#FF5B5B",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 170,
    rx: 45,
    ry: 10,
    fill: "rgba(0,0,0,0.08)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledUser);
export default __webpack_public_path__ + "static/media/DisabledUser.a9e6031df497404e71fad08b08fd4365.svg";
export { ForwardRef as ReactComponent };